export const OVERLAY = 'overlay'
export const BUTTON = 'button'
export const ESCAPE = 'escape'
export const ESCAPE_KEY = 27
export const TAB_KEY = 9
export const ENTER_KEY = 13
